(function ($) {
  DJ.addBehavior('articlePageBg', '.article-header', {
    attach: function () {
      const main = document.querySelector('#main');

      if (main) {
        main.classList.add('page-bg-gray');
      }
    }
  });
})(jQuery);
